import React from 'react';
import { TypewriterText } from '@/components/custom/typewriter-text';
import { cn } from '@/lib/utils';

// Banner "T.I.A com balão de fala" usado nas telas do aluno no tema playful.
// contentOffset/imageHeight/bubbleMaxWidth variam por imagem (cada pose da T.I.A
// tem uma largura renderizada diferente) e por isso ficam como props numéricas
// aplicadas via style — classes arbitrárias do Tailwind não aceitam valor dinâmico.
function TiaBanner({ image, imageAlt = 'T.I.A', imageHeight = 180, imageOffset = 170, imageClassName, bubbleMaxWidth = 520, bubbleCorner = 'bl', bubbleIcon, showLabel = false, text, decoration, className, children }) {
  return (
    <div
      className={cn('relative flex items-center rounded-[24px] p-4 shadow-card', className)}
      style={{ background: 'var(--color-bg-lilac)', paddingLeft: imageOffset }}
    >
      {decoration}

      <img
        src={image}
        alt={imageAlt}
        className={cn('pointer-events-none absolute bottom-0 left-2 z-10 w-auto object-contain object-bottom', imageClassName)}
        style={{ height: imageHeight }}
      />

      <div
        className={cn('relative z-10 flex items-start gap-3 rounded-[16px] bg-white p-5 shadow-card', bubbleCorner === 'bl' ? 'rounded-bl-none' : 'rounded-tl-none')}
        style={{ maxWidth: bubbleMaxWidth }}
      >
        <div>
          {showLabel && (
            <span
              className="block text-xs font-extrabold"
              style={{ color: 'var(--color-secondary-dark)' }}
            >
              T.I.A
            </span>
          )}
          <p
            className="mb-0 whitespace-pre-line text-sm font-bold leading-relaxed"
            style={{ color: '#222731' }}
          >
            <TypewriterText text={text} />
          </p>
        </div>

        {bubbleIcon && (
          <img
            src={bubbleIcon}
            alt=""
            className="h-auto w-4 shrink-0"
          />
        )}
      </div>

      {children && <div className="relative z-10 ml-auto shrink-0">{children}</div>}
    </div>
  );
}

export { TiaBanner };
